import { useTheme as useVuetifyTheme, type ThemeInstance } from "vuetify";
import { useAppConfiguration } from "@domain/AppConfiguration";

import themes from "@/theme";
import { watch } from "vue";

export function useTheme()
{
    if( ThemeManager.instance == null )
    {
        ThemeManager.instance = new ThemeManager();    
    }
    return ThemeManager.instance;
}

class ThemeManager
{

    private theme: ThemeInstance = {} as ThemeInstance;
    public static instance: ThemeManager;

    /**
     * Initialises the theme - this must be called inside App.onMounted()
     */
    initialise()
    {

        this.theme = useVuetifyTheme();

        const appConfiguration = useAppConfiguration();
        watch( () => appConfiguration.isDarkMode, value => this.setDarkMode( value ), { immediate: true } );
        watch( () => appConfiguration.theme, value => this.setTheme( value ), { immediate: true } );

    }

    /**
     * Sets the current theme, adjusting tailwind and vuetify to match the theme name
     * @param themeName 
     */
    setTheme( themeName: string )
    {

        // If the theme doesnt exist, take the first theme in the themes collection
        if( Object.keys( themes ).includes( themeName ) == false )
        {
            themeName = Object.keys( themes )[ 0 ] as string;
        }

        // Remove the previous theme & dark mode classes from the body
        const element = document.body;
        const themeClasses = element.className.split( ' ' ).filter( c => !c.startsWith( 'theme-' ) );
        
        element.className = themeClasses.join( ' ' ).trim();
        
        // Add the new theme class and optional dark mode class from the vuetify theme.
        // The theme class name activates the theme's CSS variables which will be used by tailwind
        element.classList.add( themeName );

        // Set the vuetify theme
        if( this.theme?.global != null )
        {
            this.theme.global.name.value = themeName;
        }
        
    }

    /**
     * Sets the dark mode state
     * @param value 
     */
    setDarkMode( value: boolean )
    {
        const element = document.body;
        if( value ) 
        {
            element.classList.add( 'dark' );    
        }
        else
        {
            element.classList.remove( 'dark' );    
        }
    }

}

